/**
 * Csv Schema of CargaPesquisaSatisfacao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaPesquisaSatisfacao} from '@/model/resource/CargaPesquisaSatisfacao'

/* TODO: review generated schema */
export class CsvCargaPesquisaSatisfacaoSchema extends Schema {
  readonly name = 'CsvCargaPesquisaSatisfacao'

  readonly fieldSet: FieldSet<CargaPesquisaSatisfacao> = {
    carga: schema => schema.model.carga?.$id ?? null,
    notaPergunta1: schema => schema.model.notaPergunta1,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    notaPergunta2: schema => schema.model.notaPergunta2,
    urlFotoSilenciosa: schema => schema.model.urlFotoSilenciosa,
  }
}
